import {
  OAuthIntegrationPairingModal
} from './OAuthIntegrationPairingModal';
import {
  clickupService
} from "../services/api";
import {
  OnboardingEvents
} from '../analytics/posthog';

interface ClickUpPairingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  existingLabels?: string[];
}

export function ClickUpPairingModal({
  isOpen,
  onClose,
  onSuccess,
  existingLabels,
}: ClickUpPairingModalProps) {
  return (
    <OAuthIntegrationPairingModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      existingLabels={existingLabels}
      name="clickup"
      displayName="ClickUp"
      description="Connect your ClickUp account to manage tasks and projects directly in conversations."
      features={[
        'Search and browse your tasks',
        'Create and update tasks',
        'View upcoming due dates',
        'Manage task assignments and statuses',
      ]}
      accentColor="violet"
      events={{
        modalOpened: OnboardingEvents.CLICKUP_MODAL_OPENED,
        oauthStarted: OnboardingEvents.CLICKUP_OAUTH_STARTED,
        connected: OnboardingEvents.CLICKUP_CONNECTED,
        connectionFailed: OnboardingEvents.CLICKUP_CONNECTION_FAILED,
        modalClosed: OnboardingEvents.CLICKUP_MODAL_CLOSED,
      }}
      service={clickupService}
    />
  );
}
